var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/H1Extension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import { Spacer } from "@adornis/tiptap/client/extensions/ActionbarSpacer.js";
import { Bold } from "@adornis/tiptap/client/extensions/Bold.js";
import { Document } from "@adornis/tiptap/client/extensions/Document.js";
import { History } from "@adornis/tiptap/client/extensions/History.js";
import { Italic } from "@adornis/tiptap/client/extensions/Italic.js";
import { Paragraph } from "@adornis/tiptap/client/extensions/Paragraph.js";
import { Strike } from "@adornis/tiptap/client/extensions/Strike.js";
import { Text } from "@adornis/tiptap/client/extensions/Text.js";
import { TextStyle } from "@adornis/tiptap/client/extensions/TextStyle.js";
import { TransformerHTML } from "@adornis/tiptap/client/extensions/TransformerHTML.js";
import { Underline } from "@adornis/tiptap/client/extensions/Underline.js";
import "@adornis/tiptap/client/x-tiptap.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import sanitizeHtml from "sanitize-html";
import { BaseH1 } from "../../db/extensions/text/BaseH1.js";
import "../components/x-buildify-spacing-picker.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var headingTipTapExtensions = [
  [Document, Text, TextStyle, Paragraph()],
  [TransformerHTML],
  [Bold, Italic, Underline, Strike],
  [Spacer],
  [History]
];
var H1Extension = {
  class: BaseH1,
  toolbar: { icon: "format_h1", text: { default: "H1" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-h1-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-h1-extension>
    `);
  },
  editor({ content, contentController, controllerBaseKeyPath }) {
    return html`
      <x-flex space="md">
        <x-tiptap
          mode="html"
          .extensions=${headingTipTapExtensions}
          ${contentController.field(...controllerBaseKeyPath, "text")}
        >
        </x-tiptap>
        <x-dropdown-selection
          placeholder="Textausrichtung"
          ${contentController.field(...controllerBaseKeyPath, "textAlign")}
          .selectables=${["left", "right", "center"]}
          .renderString=${(str) => str ? { left: "Links", right: "Rechts", center: "Zentriert" }[str] ?? "" : ""}
        ></x-dropdown-selection>
      </x-flex>
    `;
  },
  group: "Schriften"
};
var XH1Extension = class extends ExtensionBoilerplate {
  _content(content) {
    const emptyPlaceholder = html`
      <x-h1 ${css({ color: this.colors.tone.warning })}> Der Text muss mindestens ein Zeichen lang sein! </x-h1>
    `;
    if (!content.text)
      return emptyPlaceholder;
    return xComponents(
      html`
        <x-h1 ${css({ textAlign: content.textAlign ?? "unset", width: "100%" })}>
          ${unsafeHTML(sanitizeHtml(content.text))}
        </x-h1>
      `
    );
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          maxWidth: "100%",
          ...this.content.value?.textAlign ? { alignSelf: { left: "flex-start", right: "flex-end", center: "center" }[this.content.value.textAlign] } : {}
        }
      }
    ];
  }
};
XH1Extension = __decorateClass([
  customElement("x-h1-extension")
], XH1Extension);
export {
  H1Extension,
  XH1Extension
};
